export const locale = window.localStorage.getItem("locale") || "en";

export const defaultNotationApp =
  parseInt(process.env.VUE_APP_DEFAULT_NOTATION) || 20735;
